import { Grid } from "antd";

/**
 * Custom hook for responsive font sizing based on screen breakpoints.
 * Provides consistent sizing across order components.
 *
 * @returns Object containing sizing functions for responsive elements
 */
export const useResponsiveFontSize = () => {
  const screens = Grid.useBreakpoint();

  const getStarSize = () => {
    if (screens.xl) return "60px";
    if (screens.lg) return "48px";
    if (screens.md) return "40px";
    return "32px";
  };

  const getButtonFontSize = () => {
    if (screens.xl) return "20px";
    if (screens.lg) return "18px";
    if (screens.md) return "16px";
    return "14px";
  };

  const getButtonMinWidth = () => {
    if (screens.xl) return "120px";
    if (screens.lg) return "100px";
    if (screens.md) return "90px";
    return "80px";
  };

  const getOrderContentFontSize = () => {
    if (screens.xl) return "18px";
    if (screens.lg) return "16px";
    if (screens.md) return "14px";
    return "13px";
  };

  const getModalWidth = () => {
    if (screens.xl) return 900;
    if (screens.lg) return 800;
    if (screens.md) return 700;
    return 600;
  };

  return {
    getStarSize,
    getButtonFontSize,
    getButtonMinWidth,
    getOrderContentFontSize,
    getModalWidth,
  };
};
